// extracted by mini-css-extract-plugin
export default {"svg_wrapper":"AnimatedSVG_svg_wrapper__13UuC","draw":"AnimatedSVG_draw__BNTrK"};